import { render } from "./generalSettingsView.vue?vue&type=template&id=516a36b9"
import script from "./generalSettingsView.vue?vue&type=script&lang=js"
export * from "./generalSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__